/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";

export default function AuthFooter(props) {
	return (
		<Flex
			flexDirection={{
				base: "column",
			}}
			alignItems={{
				base: "center",
			}}
			justifyContent="space-between"
			pb="20px"
			fontSize="sm"
		>
			<Text
				color="white"
				textAlign={{
					base: "center",
				}}
				mb={{ base: "20px" }}
			>
				<Link href="https://www.tiredclub.art" target="_blank">
					Made with ❤️ by Tired Club
				</Link>
			</Text>
			<List display="flex">
				<ListItem
					me={{
						base: "20px",
					}}
				>
					<Link
						color="white"
						fontSize="sm"
						href="https://tiredclub.art/"
						target="_blank"
					>
						Website
					</Link>
				</ListItem>
				<ListItem
					me={{
						base: "20px",
					}}
				>
					<Link
						color="white"
						fontSize="sm"
						href="https://whitepaper.tiredclub.art/"
						target="_blank"
					>
						White Paper
					</Link>
				</ListItem>
				<ListItem
					me={{
						base: "20px",
					}}
				>
					<Link
						color="white"
						fontSize="sm"
						href="https://twitter.com/tired__club/"
						target="_blank"
					>
						Twitter
					</Link>
				</ListItem>
				<ListItem>
					<Link
						color="white"
						fontSize="sm"
						href="https://discord.gg/tiredclub"
						target="_blank"
					>
						Discord
					</Link>
				</ListItem>
			</List>
		</Flex>
	);
}
